module.exports = __webpack_public_path__ + "img/hongqiaokeji.5419e130.jpg";